@if (visible) {
	<app-dialog
		[visible]="true"
		[closable]="false"
		[closeOnEscape]="false"
		[modal]="true"
		[showHeader]="true"
		header="Multi-factor authentication required"
		styleClass="mfa-interstitial-dialog"
		contentStyleClass="mfa-interstitial-content">

		<div class="mfa-interstitial">
			<p class="required-note mb-s12" role="status">
				Your account must have multi-factor authentication enabled before you can continue.
				Set it up below, or sign out.
			</p>

			@if (errorMessage) {
				<app-inline-alert alertType="error" class="d-block mb-s12">{{ errorMessage }}</app-inline-alert>
			}

			@switch (stage) {
				@case ('choose') {
					<p class="mb-s8">Choose how you want to receive your verification codes:</p>
					<div class="method-choices">
						<button type="button" class="btn btn-primary method-choice"
							[disabled]="loading"
							(click)="chooseMethod(MFAMethod.AUTHENTICATOR_APP)">
							Authenticator app
						</button>
						<button type="button" class="btn btn-primary method-choice"
							[disabled]="loading"
							(click)="chooseMethod(MFAMethod.EMAIL)">
							Email
						</button>
					</div>
				}

				@case ('setup') {
					@if (method === MFAMethod.AUTHENTICATOR_APP) {
						<p class="mb-s8">Scan this QR code with your authenticator app, then enter the 6-digit code it shows.</p>
						<div class="qrcodeImage d-inline-block" aria-hidden="true">
							@if (otpAuthUri) {
								<qrcode [qrdata]="otpAuthUri" [colorDark]="'#000080'" [colorLight]="'#ffffff'" [width]="200" [errorCorrectionLevel]="'M'"></qrcode>
							}
						</div>
						<p class="manual-key mb-s8">Can't scan? Enter this key manually:
							<span class="fw-700">{{ secretKey }}</span>
						</p>
					} @else {
						<p class="mb-s8">We sent a verification code to <span class="fw-700">{{ email }}</span>. Enter it below.</p>
						<button type="button" class="btn-a11y resend"
							[disabled]="emailResendCooldown > 0 || loading"
							(click)="resendEmailCode()">
							@if (emailResendCooldown > 0) {
								Resend code in {{ emailResendCooldown }}s
							} @else {
								Resend code
							}
						</button>
						<p class="hint mb-s8">Email not arriving? You can <button type="button" class="btn-a11y inline-link" (click)="backToChoose()">use an authenticator app instead</button>.</p>
					}

					<label for="mfa-code" class="form-label">Verification code</label>
					<input id="mfa-code" name="mfa-code" type="text" inputmode="numeric" autocomplete="one-time-code"
						class="form-control code-input" [(ngModel)]="code" [disabled]="loading"
						(keyup.enter)="verifyCode()" aria-describedby="mfa-code-help" />
					<span id="mfa-code-help" class="sr-only">Enter the verification code to finish enabling multi-factor authentication.</span>

					<div class="actions">
						<button type="button" class="btn btn-accent-secondary" [disabled]="loading" (click)="backToChoose()">Back</button>
						<button type="button" class="btn btn-primary" [disabled]="loading || !code" (click)="verifyCode()">
							{{ loading ? 'Verifying…' : 'Verify and continue' }}
						</button>
					</div>
				}

				@case ('recovery') {
					<p class="mb-s8">Save these recovery codes somewhere safe. Each one can be used once if you lose access to your verification method.</p>
					<pre class="recovery-codes" tabindex="0" aria-label="Recovery codes">{{ recoveryCodes.join('\n') }}</pre>
					<button type="button" class="btn btn-accent-secondary copy" (click)="copyRecoveryCodes()">Copy codes</button>
					<div class="actions">
						<button type="button" class="btn btn-primary" [disabled]="loading" (click)="acknowledgeAndRelease()">I've saved my codes — continue</button>
					</div>
				}
			}

			<div class="sign-out-row">
				<button type="button" class="btn btn-accent-secondary sign-out-btn" (click)="signOut()">Sign out</button>
			</div>
		</div>
	</app-dialog>
}
